<template>
  <div>
    <h1 class="page-title text-left">Trap Data Details</h1>
    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">
          Details
          <router-link
            :to="{ name: 'data-adult-surveillances' }"
            class="pull-right ml-10"
            ><i class="fa fa-list"></i
          ></router-link>
          <i
            class="fa fa-pencil pointer pull-right"
            v-on:click="form.showEdit({ id: id, list: true })"
          ></i>
        </h3>
      </div>
      <div class="panel-body">
        <dl class="dl-horizontal">
          <dt>Site</dt>
          <dd>{{ siteName(form.data.trapSite.siteId) }}</dd>

          <dt>Trap Number</dt>
          <dd>{{ form.data.trapSite.trapNumber }}</dd>

          <dt>Trap Set</dt>
          <dd>{{ form.data.dateTrapSet | datetime }}</dd>

          <dt>Date Processed</dt>
          <dd>{{ form.data.dateProcessed | datetime }}</dd>

          <dt>Id Initials</dt>
          <dd>{{ form.data.idInitials }}</dd>

          <dt>Rainfall</dt>
          <dd>{{ form.data.rainfall || 0 }}</dd>

          <dt>Tested</dt>
          <dd>
            <i
              class="fa"
              :class="{
                'fa-check-square-o': form.data.tested,
                'fa-square-o': !form.data.tested,
              }"
            ></i>
          </dd>

          <dt>Work Status</dt>
          <dd>{{ form.data.workStatus }}</dd>
        </dl>

        <div>
          <!-- Nav tabs -->
          <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active">
              <a href="#mosquitoes" role="tab" data-toggle="tab"
                >Mosquitoes & Arboviral Data</a
              >
            </li>
          </ul>

          <!-- Tab panes -->
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="mosquitoes">
              <button
                class="btn btn-primary pull-right"
                @click="
                  mosquitoForm.showEdit({
                    formId: '#mosquito-edit',
                    data: { sex: 'f' },
                  })
                "
              >
                Add mosquito data
              </button>

              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Species</th>
                    <th>Gender</th>
                    <th>Count</th>
                    <th>Sample #</th>
                    <th>CDC Sample #</th>
                    <th>High Trap Count</th>
                    <th width="120"></th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="mosquito in form.data.adultSurveillanceMosquitoes"
                  >
                    <tr>
                      <td>{{ mosquitoName(mosquito.mosquitoSpeciesId) }}</td>
                      <td>{{ (mosquito.sex || 'f').toUpperCase() }}</td>
                      <td>{{ mosquito.mosquitoCount }}</td>
                      <td>{{ mosquito.sampleNumber }}</td>
                      <td>{{ mosquito.cdcSampleNumber }}</td>
                      <td>
                        <i
                          class="fa"
                          :class="{
                            'fa-check-square-o': mosquito.irregularLabResults,
                            'fa-square-o': !mosquito.irregularLabResults,
                          }"
                        ></i>
                      </td>
                      <td>
                        <a
                          class="pointer"
                          v-on:click="showMosquitoEdit(mosquito)"
                          ><i class="fa fa-pencil"></i
                        ></a>
                        <a
                          class="pointer text-danger"
                          v-on:click="mosquitoForm.destroy(mosquito.id)"
                          ><i class="fa fa-times"></i
                        ></a>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Performed By</th>
                              <th>Pool Number</th>
                              <th>Pool Size</th>
                              <th>Assay</th>
                              <th>Result</th>
                              <th width="120"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="arboviral in getArboviral(mosquito.id)">
                              <td>{{ arboviral.dateTested | datetime }}</td>
                              <td>{{ arboviral.performedBy }}</td>
                              <td>{{ arboviral.poolNumber }}</td>
                              <td>{{ arboviral.poolSize }}</td>
                              <td>{{ assayName(arboviral.assayId) }}</td>
                              <td>{{ resultName(arboviral.resultId) }}</td>

                              <td>
                                <router-link
                                  :to="{
                                    name: 'data-arboviral-details',
                                    params: { id: arboviral.id },
                                  }"
                                  ><i
                                    class="fa fa-ellipsis-h"
                                    style="margin-right: 10px;"
                                  ></i
                                ></router-link>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>
    <mosquito-form :form="mosquitoForm"></mosquito-form>
  </div>
</template>

<script>
import AdultSurveillancesServices from '@/services/AdultSurveillancesServices';
import AdultSurveillanceMosquitoServices from '@/services/AdultSurveillanceMosquitoServices';
import Form from '@/utils/form';
import loader from '@/utils/loader';
import siteForm from '@/components/forms/adult_surveillance';
import mosquitoForm from '@/components/forms/adult_surveillance_mosquito';

export default {
  name: 'adult_surveillance_details',

  components: {
    siteForm,
    mosquitoForm,
  },

  props: ['id'],

  data() {
    return {
      form: new Form(AdultSurveillancesServices, {
        trapSite: [],
      }),
      mosquitoForm: new Form(AdultSurveillanceMosquitoServices, {
        adultSurveillanceId: this.$props.id,
      }),
    };
  },

  methods: {
    siteName(id) {
      return this.$store.getters.siteNameById(id);
    },
    mosquitoName(id) {
      return this.$store.getters.mosquitoNameById(id);
    },
    assayName(id) {
      return this.$store.getters.assaysNameById(id);
    },
    resultName(id) {
      return this.$store.getters.resultsNameById(id);
    },
    updateDetails() {
      if (
        this.$route.path.indexOf('adult-surveillance-details') > -1 &&
        this.$props.id
      ) {
        AdultSurveillancesServices.getDetails(this.$props.id).then(() => {
          this.form.getDetails(this.$props.id);
        });
      }
    },
    showMosquitoEdit(mosquito) {
      this.mosquitoForm.showEdit({ id: mosquito.id, formId: '#mosquito-edit' });
      this.mosquitoForm.data = mosquito;
    },
    getArboviral(mosquitoId) {
      return _.filter(
        this.form.data.arboviralAssays,
        (o) => o.adultSurveillanceMosquitoId === mosquitoId
      );
    },
  },

  mounted() {
    loader.lookups().then(() => {
      this.form.getDetails(this.id);
    });
  },

  created() {
    window.bus.$on('item-created', () => {
      this.updateDetails();
    });

    window.bus.$on('item-updated', () => {
      this.updateDetails();
    });

    window.bus.$on('item-deleted', () => {
      this.updateDetails();
    });
  },
};
</script>

<style lang="scss"></style>
